import get from "lodash/get";
import last from "lodash/last";
import map from "lodash/map";
import find from "lodash/find";
import dayjs from "dayjs";
import pick from "lodash/pick";
import assign from "lodash/assign";
import sortBy from "lodash/sortBy";
import groupBy from "lodash/groupBy";
import some from "lodash/some";
import templateConfig from "../constants/template";
import first from "lodash/first";

export const generateStep1Payload = (values) => {
  return {
    ...values,
    reset_time: get(values, "reset_time").format("HH:mm"),
  };
};

export const generateStep2Payload = (values, localState, edit = false, templateType) => {
  const payload = [];
  let i = -1;
  map(templateConfig(templateType), (gConfig) => {
    map(get(gConfig, "fields"), (fieldConfig) => {
      const index = i + 1;
      i++;

      const value = get(values, `graph.${index}`);

      if (get(value, "module_id")) {
        const field = find(get(localState, `${index}.module.eventFieldVOS`), [
          "id",
          get(value, "event_id"),
        ]);

        payload.push({
          id: edit ? get(value, "setting_id") : undefined,
          graph_id: get(gConfig, "id"),
          field_id: get(fieldConfig, "id"),
          device_id: get(last(get(value, "device_id", [])).split("@"), "1"),
          module_id: get(value, "module_id"),
          event_id: get(field, "id"),
          event_key: get(field, "fieldName"),
        });
      }
    });
  });
  return { template_settings: payload };
};

export const generateStep3Payload = (values) => {
  return { default_values: get(values,'default_values') };
};

const findParentByChildId = (data, childId) => {
  const parentObj = find(data, (parent) =>
    some(get(parent, "children", []), { id: childId })
  );
  const device = find(get(parentObj, "children", []), ["id", childId]);
  return [get(parentObj, "value"), get(device, "value")];
};

export const generateInitialPayload = (data, devices = [], eTree = []) => {
  devices = groupBy(devices, "id");
  const settings = sortBy(get(data, "template_settings", []), "field_id");
  const localState = []; 

  const smallestId = get(first(settings), "field_id");
  const highestId = get(last(settings), "field_id");
  
  const settingsObj = Object.fromEntries(
    settings.map(setting => [
      get(setting, "field_id"),
      setting
    ])
  );

  const rangeSize = highestId - smallestId + 1;
  const idRange = Array.from({ length: rangeSize }, (_, index) => smallestId + index);

  const graph = idRange.map((i) => {
    const currentSetting = settingsObj[i];
    
    if (currentSetting) {
      const device = get(devices, `${currentSetting.device_id}.0`);
      const module = find(get(device, "modules", []), [
        "id",
        currentSetting.module_id,
      ]);
      
      localState.push({ device, module });

      return {
        setting_id: currentSetting.id,
        device_id: findParentByChildId(eTree, device?.id),
        module_id: module?.id,
        event_id: currentSetting.event_id,
      };
    } else {
      localState.push({});
      return {};
    }
  });

  const formValues = {
    step1: assign(
      {
        company_id: get(data, "company.id"),
        type_id: get(data, "type.value"),
        reset_time: dayjs(get(data, "reset_time"), "HH:mm"),
        manager_uuid:get(data,"manager.id")
      },
      pick(data, ["name"])
    ),
    step2: { graph },
    step3: get(data, "default_values"),
  };
  
  return { formValues, localState };
};



export const disabledDate = (current) => {
  if (!current) {
    return false;
  }

  const today = dayjs().startOf('day');
  const twoDaysAgo = today.subtract(4, 'day').startOf('day');

  const isAfterToday = current.isAfter(today, 'day');
  
  const isBeforeTwoDaysAgo = current.isBefore(twoDaysAgo, 'day');

  return isAfterToday || isBeforeTwoDaysAgo;
};

export const disabledTime = (current) => {
  if (!current) {
    return {};
  }

  const currentTime = dayjs();
  
  if (current.isSame(currentTime, 'day')) {
    const currentHour = currentTime.hour();
    const currentMinute = currentTime.minute();
    const currentSecond = currentTime.second();

    return {
      disabledHours: () => {
        return [...Array(24).keys()].filter(hour => hour > currentHour);
      },
      disabledMinutes: (selectedHour) => {
        if (selectedHour === currentHour) {
          return [...Array(60).keys()].filter(minute => minute > currentMinute);
        }
        return [];
      },
      disabledSeconds: (selectedHour, selectedMinute) => {
        if (selectedHour === currentHour && selectedMinute === currentMinute) {
          return [...Array(60).keys()].filter(second => second > currentSecond);
        }
        return [];
      },
    };
  }

  return {};
};